// extracted by mini-css-extract-plugin
export default {"root":"ProcedureStatusBar_root__2zqj9","row":"ProcedureStatusBar_row__Z0uM5","column":"ProcedureStatusBar_column__xkwUe"};